// extracted by mini-css-extract-plugin
export default {"container":"AppointmentWlistSuccess_container__ug-36","icon":"AppointmentWlistSuccess_icon__dVGaf","details":"AppointmentWlistSuccess_details__xTcQ7"};